"use strict"

import { EnvStage } from "common-library/ucountit-env"
import { createApiUrls } from "./apiurls"
import { Required, Optional } from "./Environment"

const hostname = "aging.retailanalysis.cloud"
const config: EnvStage<Required, Optional> = {
  port: 19500,
  host: [hostname],
  api: Object.assign(createApiUrls(hostname), {
    ioturl: "http://iot-aging.retailanalysis.cloud:19503/local-api/1.0/iot",
    faceurl: "http://secure-aging.retailanalysis.cloud:19509/api/v1",
    rebuildurl: "http://172.17.0.1:19620/api/v1",
    notiIoUrl: "http://secure-aging.retailanalysis.cloud:19640/api",
  }),

  web: {
    faceurl: "/facedashboard",
    tunnelUrl: "http://tunnel.retailanalysis.cloud",
  },

  log: {
    analyticTrackingId: "G-3CQJ3PD9PW",
  },

  s3: {
    static: {
      bucket: "ucount-it.stage",
      destination: hostname + "/static",
      region: "us-west-1",
      cloudfront: "",
    },
    firmware: {
      bucket: "ucount-it.stage",
      destination: hostname + "/firmware",
      region: "us-west-1",
    },
    face: {
      bucket: "ucount-it.stage",
      destination: hostname + "/faces",
      region: "us-west-1",
    },
    customAgency: {
      bucket: "ucount-it.stage",
      region: "us-west-1",
      destination: hostname + "/customAgency",
    },
  },

  email: {
    from: "notification@ucountit.com",
  },

  cloudFront: {
    bucket: "ucount-it.static",
    region: "us-west-1",
    prefix: "ui-dev",
    basePath: "https://cdn.retailanalysis.cloud",
  },

  brand: "aging",
}

export default config
